<template>
  <div class="user-card" :key="componentKey">
    <div
      class="left"
      :style="
        config.image.length < 1 && !isEdit
          ? 'background:url(' + notImageUrl + ') no-repeat center / cover'
          : 'background:url(' + config.image + ') no-repeat center / cover'
      "
    >
      <!--            v-if="!config.image"-->
      <template v-if="!config.isOrder">
        <div class="upload-image">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedLine"
            v-model="config.image"
            :classType="1"
            v-if="isEdit"
          />
        </div>
        <div class="clear-icon" v-if="isEdit" @click="clearImage">
          <i class="el-icon-close"></i>
        </div>
      </template>
    </div>
    <div class="right">
      <div class="title">
        <div class="title-text" v-if="config.isProduct">
          <div
            style="display: inline-block; min-width: 240px"
            :class="isEdit ? 'require-class' : ''"
          >
            Job ID:
            <div
              class="from-item"
              style="display: inline-block; width: 128px"
              v-if="isEdit"
            >
              <el-input
                v-model="config.jobId"
                size="mini"
                :placeholder="$lange == 'en' ? 'Please Input' : '请输入'"
              ></el-input>
            </div>
            <template v-else>{{
              config.jobId ? config.jobId : "---"
            }}</template>
          </div>
        </div>
        <div class="title-text" v-if="config.isProject">
          <div :class="isEdit ? 'require-class' : ''">
            Job ID:
            <template v-if="isEdit">
              <div class="from-item" style="display: inline-block">
                <el-select
                  style="width: 200px"
                  :placeholder="$lange == 'en' ? 'Please Select' : '请选择'"
                  @change="jobIdChange"
                  v-model="config.jobId"
                  size="mini"
                >
                  <el-option
                    v-for="jobIdItem in productOptions"
                    :label="jobIdItem.jobId"
                    :value="jobIdItem.jobId"
                  ></el-option>
                </el-select>
                <!--                                <cc-selector :config="productSelectorConfig"-->
                <!--                                admin/fsb/product/queryByFasIdIsNull?pageSize=999&isAsc=true-->
                <!--                                              />-->
              </div>

              <div
                class="from-item"
                :class="isEdit ? 'require-class' : ''"
                style="display: inline-block; margin-left: 35px"
              >
                {{ $lange == "en" ? "Project Status: " : "项目状态: " }}
                <el-select
                  style="width: 200px"
                  :placeholder="
                    $lange == 'en' ? 'Please Select Status' : '请选择状态'
                  "
                  v-model="config.status"
                  size="mini"
                >
                  <el-option
                    v-for="(projectItem, index) in projectStatus"
                    :label="projectItem.title"
                    :value="index"
                  ></el-option>
                </el-select>
                <!--                                <cc-constant-selector style="display:inline-block;"-->
                <!--                                                      type="select"-->
                <!--                                                      valType="String"-->
                <!--                                                      :placeholder="$lange == 'en' ? 'Please Select Status' : '请选择状态'"-->
                <!--                                                      v-model="config.status"-->
                <!--                                                      code="projectStatus"-->
                <!--                                                      api="admin/dict/pageTree" />-->
              </div>
            </template>
            <template v-else>
              {{ config.jobId ? config.jobId : "---" }}
              <div
                class="from-item"
                :class="`status-${config.status}`"
                style="display: inline-block; margin-left: 15px"
              >
                {{ projectStatus[config.status].title }}
              </div>
            </template>
          </div>
        </div>
        <div class="title-text" v-if="config.isOrder">
          <div class="title-inputs require-class" v-if="config.isOrderCreate">
            <el-select
              v-model="config.customerId"
              size="mini"
              filterable
              clearable
              :placeholder="
                $lange == 'en' ? 'Please Select Customer' : '请选择客户'
              "
              @change="customerChange"
            >
              <el-option
                v-for="op in customerOption"
                :label="op.label"
                :value="op.value"
              ></el-option>
            </el-select>
          </div>
          <p v-else>{{ config.customerName }}</p>
        </div>
        <div class="title-text" v-else>
          <div
            class="title-inputs require-class"
            v-if="isEdit && !config.isProduct && !config.isProject"
          >
            <el-input
              style="margin-left: 0"
              :placeholder="$lange == 'en' ? 'Customer name' : '请输入公司名称'"
              v-model="config.customerName"
              size="mini"
            ></el-input>
            <!--                        <el-input-->
            <!--                                placeholder="请输入英文公司名称"-->
            <!--                                v-model="config.englishName"-->
            <!--                                size="mini"-->
            <!--                        ></el-input>-->
          </div>
          <p v-else>{{ config.customerName }}</p>
        </div>

        <template v-if="!config.isOrder">
          <!--                    <template v-if="config.isProject && config.status === 3">-->
          <!--这里兼容 当项目提交验收报告的时候，隐藏所有可操作项目的按钮-->
          <!--                    </template>-->
          <!--                    <template v-else>-->
          <div class="btn-group" v-if="isEdit">
            <el-button type="info" size="mini" @click="edit('cancel')">{{
              $lange == "en" ? "Cancel" : "取消"
            }}</el-button>
            <el-button type="primary" size="mini" @click="save">{{
              $lange == "en" ? "Save" : "保存"
            }}</el-button>
          </div>
          <div class="btn-group" v-else>
            <el-button size="mini" @click="edit" icon="el-icon-edit">{{
              $lange == "en" ? "Edit" : "编辑"
            }}</el-button>
          </div>
          <!--                    </template>-->
        </template>
      </div>
      <div class="right-form">
        <div
          class="item"
          v-for="(item, index) in config.formLists"
          :key="index"
        >
          <div
            class="block"
            :class="item.required ? 'require-class' : ''"
            v-if="isEdit && !config.isOrderEdit"
          >
            <p>
              {{ item.name }} :
              {{
                item.disabled
                  ? item.value.length < 1
                    ? "---"
                    : item.value
                  : ""
              }}
            </p>
            <template v-if="!item.disabled">
              <div class="from-item" v-if="item.type == 'input'">
                <el-input
                  v-model="item.value"
                  size="mini"
                  :placeholder="item.placeholder"
                  :disabled="item.disabled"
                  :style="item.width ? `width: ${item.width}px` : ''"
                ></el-input>
              </div>
              <div class="from-item" v-else-if="item.type == 'constant-select'">
                <!--       暂时注释 暂时没有api -->
                <cc-constant-selector
                  style="display: inline-block"
                  type="select"
                  valType="String"
                  :placeholder="item.placeholder"
                  v-model="item.value"
                  :code="item.key"
                  api="admin/dict/pageTree"
                />
              </div>
              <div
                class="from-item"
                style="flex: 58%"
                v-else-if="item.type == 'address'"
              >
                <globalSelect v-model="item.value"></globalSelect>
              </div>
              <div
                class="from-item"
                v-else-if="item.type == 'select' && item.key == 'managerName'"
              >
                <!--                            暂时注释 暂时没有api -->
                <!--                            <cc-selector :config="item.selectConfig"-->
                <!--                                         v-model="item.customerId" />-->
                <el-select
                  v-model="item.managerId"
                  size="mini"
                  :placeholder="item.placeholder"
                  @change="managerChange"
                >
                  <el-option
                    v-for="op in managerOption"
                    :label="op.label"
                    :value="op.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="from-item" v-else-if="item.type == 'select'">
                <!--                            暂时注释 暂时没有api -->
                <!--                            <cc-selector :config="item.selectConfig"-->
                <!--                                         v-model="item.customerId" />-->
                <el-select
                  v-model="item.value"
                  size="mini"
                  filterable
                  clearable
                  :placeholder="item.placeholder"
                  @change="customerChange"
                >
                  <el-option
                    v-for="op in customerOption"
                    :label="op.label"
                    :value="op.value"
                  ></el-option>
                </el-select>
              </div>

              <div class="from-item" v-else-if="item.type == 'datetimerange'">
                <el-date-picker
                  v-model="item.value"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="mini"
                ></el-date-picker>
              </div>

              <div class="from-item" v-else-if="item.type == 'datetime'">
                <el-date-picker
                  v-model="item.value"
                  type="datetime"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <div class="from-item" v-else-if="item.type == 'date'">
                <el-date-picker
                  v-model="item.value"
                  type="date"
                  size="mini"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <div class="from-item" v-else-if="item.type == 'daterange'">
                <el-date-picker
                  v-model="item.value"
                  type="daterange"
                  size="mini"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions2"
                  @change="daterangeChange"
                ></el-date-picker>
              </div>
            </template>
          </div>
          <p v-else>{{ item.name }} : {{ item.value ? item.value : "----" }}</p>
        </div>
      </div>
      <div
        class="row-clip"
        :class="isEdit ? 'require-class' : ''"
        v-if="config.isProduct"
        style="
          margin-top: 15px;
          display: inline-block;
          max-width: 580px;
          font-size: 16px;
        "
      >
        {{ $lange == "en" ? "Address" : "地址" }}:
        <div class="from-item" style="display: inline-block" v-if="isEdit">
          <!--                    <el-input-->
          <!--                            v-model="config.productAddress"-->
          <!--                            size="mini"-->
          <!--                            placeholder="请输入详细地址"-->
          <!--                    ></el-input>-->
          <globalSelect v-model="config.productAddress"></globalSelect>
        </div>
        <template v-else>{{
          config.productAddress ? config.productAddress : "---"
        }}</template>
      </div>
    </div>
  </div>
</template>

<script>
let notImageUrl = require("../assets/not-image.png");
import globalSelect from "./globalSelect";
export default {
  name: "UserCard",
  components: {
    globalSelect,
  },
  props: {
    config: {
      type: Object,
      required: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notImageUrl: notImageUrl,
      pickerOptions2: {
        shortcuts: [
          {
            text: "一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();

              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "三年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      image: "",
      isEdit: false,
      uploaderConf2: this.$uploadUtils.config,
      isDateChange: false,
      customerOption: [],
      productOptions: [],
      projectStatus: [
        // {title: this.$lange=='en' ? "Preparing" : '准备'},
        // {title: this.$lange=='en' ? "Installation" : '安装'},
        // {title: this.$lange=='en' ? "Commissioning" : '调试'},
        // {title: this.$lange=='en' ? "Acceptance" : '验收'},
        { title: "Preparing" },
        { title: "Installation" },
        { title: "Commissioning" },
        { title: "Acceptance" },
      ],
      lastConfig: {},
      componentKey: 0,
      productSelectorConfig: {
        api: "admin/fsb/product/queryByFasIdIsNull?pageSize=999&isAsc=true",
        valProp: "jobId",
        labelProp: "jobId",
        width: "100%",
      },
      svaeSwitch: true,
    };
  },
  methods: {
    jobIdChange(id) {
      let data = {
        jobId: id,
      };
      this.ccRequest.do("admin/fsb/product/query", data, "GET").then((res) => {
        let arr = [
          "productLine",
          "speed",
          "breadth",
          "stackedLayers",
          "corrugatedLayers",
          "customerName",
        ];
        let data = res.rows[0];
        for (let i in this.config.formLists) {
          if (arr.indexOf(this.config.formLists[i].key) > -1) {
            if (this.config.formLists[i].key == "customerName") {
              // console.log(data);
              this.config.formLists[i].customerId = data.customerId;
              this.config.formLists[i].value = `${data.customer.customerName}`;
            } else {
              this.config.formLists[i].value =
                data[this.config.formLists[i].key];
            }
          }
        }
        console.log(this.config.formLists);
      });
    },
    daterangeChange() {
      this.isDateChange = true;
    },
    managerChange(res) {
      let id = res;
      for (let i in this.config.formLists) {
        if (this.config.formLists[i].key == "managerName") {
          for (let j in this.managerOption) {
            if (this.managerOption[j].userId == id) {
              this.config.formLists[i].value = this.managerOption[j].userName;
            }
          }
        }
      }
      // this.config
    },
    customerChange(res) {
      console.log(res);
      let id = res;
      // for(let j in this.customerOption){
      //     if(this.customerOption[j].value == res){
      //         id = this.customerOption[j].value;
      //     }
      // }
      if (this.config.isOrder) {
        this.config.cursotmerId = id;
        this.ccRequest
          .do("admin/fsb/customer/get", { id: id }, "GET")
          .then((res2) => {
            this.config.customerName = res2.customerName;
            this.config.englishName = res2.englishName;
            this.config.image = res2.imageUrl;
            for (let i in this.config.formLists) {
              this.config.formLists[i].value =
                res2[this.config.formLists[i].key];
              if (this.config.formLists[i].key === "discount") {
                this.config.formLists[i].value /= 10;
              }
            }
            this.$emit("clear-job", res2);
          });
        return false;
      }
      for (let i in this.config.formLists) {
        if (this.config.formLists[i].key == "customerId") {
          this.config.formLists[i].customerId = id;
          // console.log(this.config.formLists[i].customerId, "customerId")
          this.config.formLists[i].value = res;
        }
      }
    },
    //控制 是否启用编辑
    edit(type = false) {
      if (type == "cancel") {
        if (this.isCreate) {
          this.$router.go(-1);
        }
        for (let i in this.config.formLists) {
          if (
            this.config.formLists[i].type == "daterange" &&
            this.config.formLists[i].value.length == 2
          ) {
            let res = `${this.config.formLists[i].value[0]}~${this.config.formLists[i].value[1]}`;
            this.config.formLists[i].value = res;
          }
        }
        this.isEdit = false;
        this.config = JSON.parse(this.lastConfig);
        console.log(
          JSON.parse(this.lastConfig),
          "this.lastConfigthis.lastConfigthis.lastConfig"
        );
      } else {
        this.isEdit = true;
      }
    },
    //保存
    save() {
      if (!this.svaeSwitch) {
        return false;
      }
      this.svaeSwitch = false;
      let data = {};
      for (let i in this.config.formLists) {
        if (this.config.postKey.indexOf(this.config.formLists[i].key) > -1) {
          if (
            this.config.formLists[i].key == "customerId" ||
            this.config.formLists[i].key == "customerName"
          ) {
            console.log("customerId");
            data[`customerId`] = this.config.formLists[i].customerId;
          } else if (
            this.config.formLists[i].type == "daterange" &&
            this.isDateChange
          ) {
            data[
              `${this.config.formLists[i].key}`
            ] = `${this.config.formLists[i].value[0]}~${this.config.formLists[i].value[1]}`;
          } else if (this.config.formLists[i].key == "managerName") {
            data["managerId"] = this.config.formLists[i].managerId;
          } else {
            data[`${this.config.formLists[i].key}`] =
              this.config.formLists[i].value;
          }
        }
      }

      if (this.config.image) {
        data.imageUrl = this.config.image;
      }
      if (this.config.jobId) {
        data.jobId = this.config.jobId;
      }
      if (this.config.productAddress) {
        data.productAddress = this.config.productAddress;
      }

      if (this.config.customerName != undefined) {
        data.customerName = this.config.customerName;
        if (data.customerName.length < 1) {
          this.svaeSwitch = true;
          return this.$message({
            type: "warning",
            message: "客户名称不能为空",
          });
        }
        if (data.customerNo.length < 1) {
          this.svaeSwitch = true;
          return this.$message({
            type: "warning",
            message: "请输入客户ID",
          });
        }
        if (data.discount > 1) {
          this.svaeSwitch = true;
          return this.$message({
            type: "warning",
            message: "折扣请输入 0 ~ 1",
          });
        }
        data.discount *= 10;
      }

      if (this.config.id) {
        data.id = this.config.id;
      }
      if (this.config.status !== undefined) {
        data.status = this.config.status;
      }
      if (this.config.isProject) {
        if (data.managerId.length < 1) {
          this.svaeSwitch = true;
          this.$message({
            type: "warning",
            message: "请选择客户经理",
          });
          return false;
        }
        if (data.jobId.length < 1) {
          this.svaeSwitch = true;
          this.$message({
            type: "warning",
            message: "请选择jobId",
          });
          return false;
        }
        if (!data.status && data.status !== 0) {
          // alert(data.status);
          this.svaeSwitch = true;
          this.$message({
            type: "warning",
            message: "请选择项目状态",
          });
          return false;
        }
        if (!data.fasId || data.fasId.length < 1) {
          this.svaeSwitch = true;
          this.$message({
            type: "warning",
            message: "请输入正确的FAS Id",
          });
          return false;
        }
      }
      if (this.config.isProduct) {
        if (!data.jobId || data.jobId.length < 1) {
          this.svaeSwitch = true;
          this.$message({
            type: "warning",
            message: "请输入正确的JOB Id",
          });
          return false;
        }
        if (!data.productAddress || data.productAddress.length < 1) {
          this.svaeSwitch = true;
          this.$message({
            type: "warning",
            message: "请输入地址",
          });
          return false;
        }
      }

      //擴展校驗
      if (this.config.requiredList) {
        if (this.config.requiredList.warrantyTime) {
          if (!data.warrantyTime || data.warrantyTime == "") {
            this.svaeSwitch = true;
            this.$message({
              type: "warning",
              message: "请选择保修时间",
            });
            return false;
          }
        }
      }
      this.ccRequest
        .do(this.config.api, data, "POSTJSON")
        .then((res) => {
          let path = "";
          let query = {};
          if (this.$router.history.current.name == "CustomerCreate") {
            path = "/admin/customer/description";
            query = {
              customerId: res.id,
            };
          } else if (this.$router.history.current.name == "ProductCreate") {
            path = "/admin/product/description";
            query = {
              productId: res.id,
            };
          } else if (this.$router.history.current.name == "ProjectCreate") {
            path = "/admin/project/description";
            query = {
              fasId: res.fasId,
            };
          } else {
            this.isEdit = false;
            this.$emit("saveSuccess");
          }
          this.lastConfig = JSON.stringify(this.config);
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.svaeSwitch = true;
          if (this.isCreate) {
            this.$router.push({
              path: path,
              query: query,
            });
          }
        })
        .catch((res) => {
          this.svaeSwitch = true;
          this.$message({
            type: "danger",
            message: res.response.data.message,
          });
        });
    },
    // 清除图片
    clearImage() {
      this.config.image = "";
    },
    getCustomer() {
      this.ccRequest
        .do("admin/fsb/customer/query", { pageSize: 9999 }, "GET")
        .then((res) => {
          let customerOption = [];
          if (res.rows && res.rows.length > 0) {
            for (let i in res.rows) {
              customerOption.push({
                label: `${res.rows[i].customerName}`,
                value: res.rows[i].id,
              });
            }
          }
          this.customerOption = customerOption;
        });
    },
    getManager() {
      this.ccRequest
        .do("admin/fsb/project/getManagerInfo", {}, "GET")
        .then((res) => {
          let managerOption = [];
          if (res && res.length > 0) {
            for (let i in res) {
              managerOption.push({
                label: `${res[i].username}`,
                value: res[i].userid,
              });
            }
          }
          this.managerOption = managerOption;
        });
    },
    getProduct() {
      this.ccRequest
        .do(
          "admin/fsb/product/queryByFasIdIsNull",
          { pageSize: 9999, isAsc: true },
          "GET"
        )
        .then((res) => {
          this.productOptions = res.rows;
        });
    },
  },
  mounted() {
    this.getCustomer();
    this.getManager();
    this.getProduct();
    setTimeout(() => {
      this.lastConfig = JSON.stringify(this.config);
    }, 1500);

    if (this.isCreate) {
      this.isEdit = true;
    } else {
    }
  },
};
</script>
<style scoped lang="scss">
.user-card {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
  background: #ffffff;
  .left {
    width: 260px;
    height: 200px;
    position: relative;
    img {
      display: block;
    }
    .clear-icon {
      padding: 1px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #ff0000;
      cursor: pointer;
      border: 1px solid #ff0000;
      border-radius: 50%;
      transform: translateX(50%) translateY(-50%);
    }
  }
  .right {
    color: #6f6f6f;
    flex: 1;
    margin-left: 35px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .title {
      display: flex;
      justify-content: space-between;
      .title-text {
        font-size: 20px;
        font-weight: bolder;
        color: #6f6f6f;
        display: flex;
        align-items: center;
      }
      .title-inputs {
        display: flex;

        .el-input:last-child {
          margin-left: 10px;
        }
      }
    }

    .right-form {
      display: flex;
      flex-wrap: wrap;
      max-width: 1024px;
      font-size: 16px;
      .item {
        min-width: 240px;
        height: 28px;
        margin-top: 20px;
        margin-right: 60px;

        .block {
          display: flex;

          p {
            /*min-width: 10%;*/
            /*text-align: right;*/
            /*display: inline-block;*/
            white-space: nowrap;
            margin-right: 10px;
          }

          .from-item {
            flex: 0 54%;
          }
        }
      }
    }
  }
}
.status- {
  &0 {
    color: #909399;
  }
  &1 {
    color: #67c23a;
  }
  &2 {
    color: #e6a23c;
  }
  &3 {
    color: #f56c6c;
  }
}
.el-select-dropdown__item {
  padding-left: 14px;
}
</style>
